import isEmpty from 'lodash/isEmpty'
import type { File } from '@ztechapps/common.contract'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { HorizontalStack, Icon, TooltipPopOver } from '@ztechapps/webui.util'
import styles from './StagedAttachments.module.scss'

export type StagedAttachmentsProps = {
  attachments: File[]
  onRemove: (fileId: string) => void
  disabled?: boolean
}

export const StagedAttachments = ({ attachments, onRemove, disabled }: StagedAttachmentsProps) => {
  if (isEmpty(attachments)) return null

  return (
    <HorizontalStack gap={1} className="flex-wrap mt-2">
      {attachments.map((file) => (
        <HorizontalStack
          key={file._id}
          gap={1}
          className={`${styles.chip} border rounded bg-body-tertiary px-2 py-1 small`}
          style={{ minWidth: 0, maxWidth: '100%' }}
        >
          <Icon name="paperclip" />
          <TooltipPopOver tooltipBody={file.name} clickThrough>
            <a
              href={file.uri}
              target="_blank"
              rel="noopener noreferrer"
              className="text-truncate"
              style={{ minWidth: 0 }}
            >
              {file.name}
            </a>
          </TooltipPopOver>
          <BusyButtonLink
            bsStyle="danger"
            icon="xmark"
            title={`Remove ${file.name}`}
            className={`${styles.remove} flex-shrink-0`}
            disabled={disabled}
            onClick={() => onRemove(file._id)}
          />
        </HorizontalStack>
      ))}
    </HorizontalStack>
  )
}
